
<div *ngIf="show">
    <div class="delete">
        <h3 class="delete-text">Delete Account</h3>
    </div>
    <div class="trash">
        <i class="fa fa-trash-o" style="font-size:35px;color:red"></i>
    </div>

    <div class="account">
        <h3 class="account-details">Delete Your Account Permanently</h3>
    </div>
    <div>
        <h5 class="deleting">Deleting account will do the following:</h5>
    </div>
    <ol class="list">
        <li class="remove-list">
            Your account information, including will be permanently removed from our system.
        </li>
        <li class="remove-list">
            Multiple accounts, if associated, with the phone number will also be removed.
        </li>
        <li class="remove-list">
            you will no longer be able to access sri chaitanya once the account is delected.
        </li>
        <li class="remove-list">
            you will loose access to records of all the activity done on the platforms.
        </li>
        <li class="remove-list">
            Data associated with your account will be deleted according to our data retention policy.<br>
             you can find more details in our privacy policy.
        </li>
    </ol>
    <div class="terms">
        <input type="checkbox" [(ngModel)]="isChecked" (change)="onCheckboxChange()"> 
        <label for="" class="checkcondition">Terms&conditions</label>
    </div>
    <div>
        <div class="later">
            <button type="button" class="btn-later" (click)="dialogclose()">I'LL DO LATER</button>
        </div>
        <div class="continue pb-4">
            <button type="button" class="btn-continue " (click)="success()" [disabled]="!isChecked">CONTINUE TO DELETE</button>
        </div>
    </div>
</div>

<div *ngIf="!show">
    <div class="right-tick">
        <i class="fa fa-check"></i>
    </div>
    <div class="submit-text">
        <h4>{{accountdeletedetails.message}}</h4>
        <!-- <h4>Account deactivation request </h4>
        <h4>submitted successfully.</h4> -->
    </div>
    <div class="text-center pt-4 pb-4">
        <button class="submit" (click)="submit()" routerLink="/parent">ok</button>
    </div>
</div>

<!-- ================== loader ==================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>